/**
 * @author David Oravec<xorave06@stud.fit.vutbr.cz>
 */
import React from 'react';
import {useMatch, useResolvedPath} from "react-router-dom";
import {Button, ButtonProps} from "@mui/material";

function CustomNavButton({ children, to, ...props }): ButtonProps {
    let resolved = useResolvedPath(to);
    const match = useMatch({ path: resolved.pathname, end: true });
    return (
        <div>
            <Button
                {...props}
                color={match? "warning": "primary"}
            >
                {children}
            </Button>
        </div>
    );
}

export default CustomNavButton;